import { __require as requireZhCn } from "../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/locale/zh-cn.js";
requireZhCn();
//# sourceMappingURL=zh-cn.js.map
